import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexTranscriberCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { contractorId } = this.props;
    return (
      <Card body>
        <div className="p">Have a question?</div>
        <div className="p large">
          <a href="https://docs.google.com/document/d/19M4nOtK_dFKzZHSroA5KQep1NenXMnh2NpTc4B8byu4/edit">
            Read the FAQ.
          </a>
        </div>
        <br />
        <a href={"/contractor_users/" + contractorId}>View your profile</a>
        <br />
        <br />
        <div className="h3 large">Helpful resources</div>
        <ul>
          <li>
            <a href="https://docs.google.com/document/d/1a9602ZLbDr-xW8UWPTFwE54gkIHERiX_sLjfHN5C-58/edit?usp=sharing">
              Welcome kit
            </a>
          </li>
          <li>
            <a href="/privacy_policies">Privacy Policies</a>
          </li>
          <br />
          <li>
            Running into an issue? Check our
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfYar0w8tUbe9mFA37bXCYp6x67-BbEQSr5hV2RY5VZijolnA/viewform?usp=send_form">
              {" "}
              issues tracker for help.
            </a>
          </li>
          <br />
          <li>
            To understand how your transcripts are rated, please view our
            <a href="https://docs.google.com/document/d/1sMPnNNwyuMq1IsDU-12cT-74JUAx3J9A3lg5sFZfHOA/edit?usp=drivesdk">
              {" "}
              quality rating guidelines
            </a>
            .
          </li>
          <br />
          <li>
            Still need help? Ask questions on our
            <a href="https://voiceopshq.slack.com"> Slack </a>
            or email
            <a href="mailto:help@qa-world.com"> help@qa-world.com</a>.
          </li>
        </ul>
        <br />
        <a href="/contractor_users/logout">Logout</a>
      </Card>
    );
  }
}
